'use client';

declare global {
  interface Window {
    gtag: (
      event: string,
      eventName: string,
      params: {
        event_category: string;
        event_label: string;
        value?: number;
        items?: { item_id: string; item_name: string }[];
      }
    ) => void;
  }
}

import { useState } from 'react';
import { signIn } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { PublicPageLayout } from '@letsgo/PublicPageLayout';
import { SignupForm } from '../../../components/auth/SignupForm'; // Corrected import path
import React from 'react'; // Added missing import for React
import { SvgIcon } from '@mui/material';

export default function SignupPage() {
  // Keep general error and success states for overall page feedback
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isClientLoading, setIsClientLoading] = useState(true); // New state for CSR indication

  const handleSignupSuccess = () => {
    setSuccess('Registration successful! Please check your email for a verification link.');
    setError('');
  };

  const handleSignupFailure = (message: string) => {
    setError(message);
    setSuccess('');
  };

  // Simulate client-side loading for demonstration. In a real app, this might depend on data fetching.
  // For now, we'll just set it to false after a short delay.
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsClientLoading(false);
    }, 500); // Simulate 0.5s loading time
    return () => clearTimeout(timer);
  }, []);

  return (
    <PublicPageLayout>
      <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 24 }}>
        <h2 id="signup-heading">Sign Up</h2>
        {error && <div style={{ color: 'red' }}>{error}</div>}
        {success && <div style={{ color: 'green' }}>{success}</div>}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%', maxWidth: 260, marginBottom: 20 }}>
          <button onClick={() => signIn('google')} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '10px 20px', background: '#ea4335', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '1em' }}>
            <SvgIcon viewBox="0 0 24 24" sx={{ fontSize: 20 }}>
              <path d="M21 12.3c0-.7-.1-1.4-.3-2.1H12v3.9h5.5c-.2 1-1 2.6-2.6 3.4l.1.7 3.8 2.9.3.1c2.2-2 3.6-5 3.6-8.9z" />
            </SvgIcon>
            Sign up with Google
          </button>
          <button onClick={() => signIn('github')} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '10px 20px', background: '#333', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '1em' }}>
            <SvgIcon viewBox="0 0 24 24" sx={{ fontSize: 20 }}>
              <path d="M12 .5A12 12 0 0 0 0 12.7c0 5.3 3.4 9.8 8.1 11.4.6.1.8-.3.8-.6v-2.1c-3.3.7-4-1.6-4-1.6-.5-1.3-1.2-1.6-1.2-1.6-1-.7.1-.7.1-.7 1.1.1 1.7 1.2 1.7 1.2 1 .1 1.6.7 2 1.2.2-.9.5-1.6.9-2-2.7-.3-5.6-1.4-5.6-6 0-1.3.5-2.4 1.2-3.3-.1-.3-.5-1.5.1-3 0 0 1-.3 3.3 1.2a11 11 0 0 1 6 0c2.3-1.5 3.3-1.2 3.3-1.2.6 1.5.2 2.7.1 3 0 .9.6 2 1.2 3.3 0 4.6-2.9 5.7-5.7 6 .5.4.9 1.1.9 2.3v3.4c0 .3.2.7.9.6A12 12 0 0 0 24 12.7 12 12 0 0 0 12 .5z" />
            </SvgIcon>
            Sign up with GitHub
          </button>
        </div>

        <div style={{ width: '100%', maxWidth: 260, textAlign: 'center', position: 'relative', marginBottom: 20 }}>
          <hr style={{ borderTop: '1px solid #eee', position: 'absolute', width: '100%', top: '50%', transform: 'translateY(-50%)', zIndex: 0 }} />
          <span style={{ background: 'white', padding: '0 10px', position: 'relative', zIndex: 1, color: '#666' }}>Or</span>
        </div>

        {isClientLoading ? (
          <div style={{ padding: '20px', border: '1px solid #eee', borderRadius: '8px', background: '#f9f9f9' }}>Loading form...</div> // Simple loading indicator
        ) : (
          <SignupForm onSuccess={handleSignupSuccess} onFailure={handleSignupFailure} />
        )}

        <div style={{ marginTop: 16 }}>
          Already have an account? <a href="/auth">Sign in</a>
        </div>
      </div>
    </PublicPageLayout>
  );
}
